/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Main_Simple_Dingo_BoilInputs */

const fr_main_simple_dingo_boil = /** @type {(inputs: Main_Simple_Dingo_BoilInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clôturer la demande`)
};

/**

* @param {Main_Simple_Dingo_BoilInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const main_simple_dingo_boil = /** @type {((inputs?: Main_Simple_Dingo_BoilInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Main_Simple_Dingo_BoilInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_main_simple_dingo_boil(inputs)
});